import React from 'react'
import WordBank from './word-bank/create-dialog/create-dialog.container'
import Exercise from './exercise-slide/create-dialog/create-dialog.container'
import Image from './image-slide/create-dialog/create-dialog'
import LinkSlide from './link-slide/create-dialog/create-dialog'
import SuccessCriteria from './success-criteria-slide/create-dialog/create-dialog.container'
import Text from './text-slide/create-dialog/create-dialog.container'
import Video from './video-slide/create-dialog/create-dialog.container'
import { SelectWorkModal } from './exemplar-slide/select-work/select-work'

export const CreateSlideDialogs = () => {
  return (
    <>
      <Text />
      <Image />
      <Video />
      <LinkSlide />
      <WordBank />
      <Exercise />
      <SuccessCriteria />
      <SelectWorkModal />
    </>
  )
}
